/**
 * Update Cart Quantity Action
 * Triggered by: arc:action:updateCartQuantity
 */

export const runUpdateCartQuantity = async (data = {}) => {
    try {
        const { variantKey, quantity } = data;
        
        if (!variantKey) {
            throw new Error('Variant key is required');
        }

        if (quantity < 0) {
            throw new Error('Quantity must be positive');
        }

        // Trigger haptic feedback
        if ('vibrate' in navigator) {
            navigator.vibrate(30);
        }

        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                line: variantKey,
                quantity: quantity,
            }),
        });

        if (!response.ok) {
            throw new Error('Failed to update cart quantity');
        }

        const updatedCart = await response.json();

        // Dispatch success event
        window.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: updatedCart, action: 'quantity_update' }
        }));

        return {
            success: true,
            cart: updatedCart,
            message: 'Quantity updated successfully'
        };

    } catch (error) {
        console.error('Update cart quantity error:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

export default runUpdateCartQuantity;
